import React from "react"
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../componets/Header";
import { FaCircleArrowLeft } from "react-icons/fa6";
import NoData from "../../componets/NoData";

const Development = () => {


    return (
        <div>
            <Header>
                <div className="d-flex w-100">
                    <div className="d-flex gap-2 align-items-center">
                        <Link
                            to="/">
                            <FaCircleArrowLeft size={20} />
                        </Link>
                        <h4 className="mb-0">Development</h4>
                    </div>
                </div>
            </Header>
            <Container>
                <Row>
                    <Col sm={12}>
                        <NoData />
                    </Col>
                </Row>
            </Container>

        </div>
    )
}

export default Development;